export const COMPANY_LIST_TYPES = {
  OWNED: "myLists",
  INVITED_TO: "sharedWithMe",
  SMART_LIST: "smartList",
};
export const COMPANY_LIST_FILTERS = "companyList.filters";
